import React, { FunctionComponent, PropsWithChildren } from 'react';

import { Header, Main } from '@vwfs-bronson/bronson-react';
import { useNavigate } from '../../services/routing';
import { HeaderLogo } from '../HeaderLogo/HeaderLogo';
import { Footer } from '../Layout/Footer';
import { Page } from '../../types/footer';

export type DefaultLayoutProps = {
  pages: Page[];
};

export const LoginLayout: FunctionComponent<PropsWithChildren<DefaultLayoutProps>> = ({ children, pages }) => {
  const navigate = useNavigate();

  return (
    <>
      <Header testId="loginHeader" staticHeader logo={<HeaderLogo navigationFn={() => navigate.root()} />} />
      <Main>{children}</Main>
      <Footer pages={pages} />
    </>
  );
};
